module.exports = __webpack_public_path__ + "static/media/121524c1-8d82-4155-bfb3-fd2f15f09e93.ea3da238.woff";